import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router";
import { useSession } from "../../app/session.js";
import { trpc, trpcErrorCode } from "../../app/trpc.js";
import { Button, Notice, PageTitle, Screen, Spinner } from "../../ui/index.js";

export function InvitePage() {
  const { t } = useTranslation();
  const { token = "" } = useParams();
  const session = useSession();
  const navigate = useNavigate();
  // getInvite это mutation (POST), чтобы токен не попадал в URL запроса и логи сервера.
  const invite = useMutation(trpc.auth.getInvite.mutationOptions({ retry: false }));
  const lookup = invite.mutate;
  useEffect(() => {
    if (token) lookup({ token });
  }, [token, lookup]);
  const accept = useMutation(
    trpc.auth.acceptInvite.mutationOptions({
      onSuccess: async () => {
        await session.refresh();
        navigate("/", { replace: true });
      },
    }),
  );

  const acceptError = (err: unknown) => {
    const c = trpcErrorCode(err);
    if (c === "forbidden") return t("invite.wrongEmail");
    if (c === "conflict") return t("invite.ownerExists");
    return t("common.error");
  };

  if (invite.isPending || session.loading) return <Spinner />;
  return (
    <Screen>
      <PageTitle>{t("invite.title")}</PageTitle>
      {invite.isError || !invite.data ? (
        <Notice kind="error">{t("invite.invalid")}</Notice>
      ) : (
        <div className="space-y-4">
          <p>{t("invite.text", { salon: invite.data.salonName, role: t(`invite.roles.${invite.data.role}`) })}</p>
          {session.user ? (
            <Button className="w-full" onClick={() => accept.mutate({ token })} disabled={accept.isPending}>
              {t("invite.accept")}
            </Button>
          ) : (
            <Link to={`/login?next=/invite/${token}`} className="block">
              <Button className="w-full">{t("invite.loginFirst")}</Button>
            </Link>
          )}
          {accept.isError && <Notice kind="error">{acceptError(accept.error)}</Notice>}
        </div>
      )}
    </Screen>
  );
}
